export default __webpack_public_path__ + "static/media/github.44eee0c4.png";